// extracted by mini-css-extract-plugin
export var hero_image = "hero_image_section-module--hero_image--53db3";
export var hero_image_body = "hero_image_section-module--hero_image_body--5334a";
export var hero_image_box = "hero_image_section-module--hero_image_box--1f56c";
export var logo = "hero_image_section-module--logo--cec0f";
export var small_steam_logo = "hero_image_section-module--small_steam_logo--5d843";